import { DataGrid, GridColDef, GridEventListener } from "@mui/x-data-grid";
import React from "react";

type DatagridDisplayProps = {
  isLoading?: boolean;
  rows: any[];
  columns: GridColDef[];
  disableRowSelectionOnClick?: boolean;
  disableColumnSelector?: boolean;
  onRowClick?: GridEventListener<"rowClick">;
};

const DatagridDisplay: React.FC<DatagridDisplayProps> = ({
  columns,
  isLoading,
  rows,
  disableRowSelectionOnClick = false,
  disableColumnSelector = false,
  onRowClick,
}) => {
  return (
    <DataGrid
      onRowClick={onRowClick}
      disableRowSelectionOnClick={disableRowSelectionOnClick}
      disableColumnSelector={disableColumnSelector}
      hideFooter
      loading={isLoading}
      columns={columns}
      rows={rows}
    />
  );
};

export default DatagridDisplay;
